import script from "./sensitive-file-list-section.vue?vue&type=script&setup=true&lang=ts"
export * from "./sensitive-file-list-section.vue?vue&type=script&setup=true&lang=ts"

import "./sensitive-file-list-section.vue?vue&type=style&index=0&id=1f9f3e65&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f9f3e65"]])

export default __exports__